var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6331 0.209741L7.66032 16.9207L2.36693 11.0128C2.11637 10.7332 1.71009 10.7332 1.45947 11.0128L0.854551 11.688C0.603984 11.9676 0.603984 12.4211 0.854551 12.7008L7.20661 19.7903C7.45718 20.0699 7.86345 20.0699 8.11407 19.7903L24.1455 1.89776C24.396 1.6181 24.396 1.16466 24.1455 0.884948L23.5405 0.209741C23.2899 -0.0699138 22.8836 -0.0699138 22.6331 0.209741Z",
    fill: "#13B597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionTick);
export default __webpack_public_path__ + "static/media/subscription-tick.2196aa99e0c3ee0ea1bdda014cddaee5.svg";
export { ForwardRef as ReactComponent };